import React from "react";
import { Helmet } from "react-helmet";

const SITE_NAME = "Sare Auctioneers";
const DEFAULT_DESCRIPTION = "Fair and transparent land auctions across Kenya, with verified property listings, clear title information, and trusted valuation guidance.";

export default function SEO({ title, description = DEFAULT_DESCRIPTION, image = "/sare-logo.png", structuredData }) {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const canonicalUrl = typeof window !== "undefined" ? window.location.href.split("?")[0] : "/";

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={`${typeof window !== "undefined" ? window.location.origin : ""}${image}`} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}
